<template>
  <multiselect-item
    id="avlChip"
    v-model="avlChip"
    :custom-label="label"
    :options="avlChipOptions"
    placeholder="Seleccione Avl Chip"
    track-by="id_avl"
    :loading="isLoading"
  ></multiselect-item>
</template>

<script>
import { get } from "lodash-es";
import axios from "axios";

export default {
  name: "SelectAvlChip",
  props: ["value"],
  beforeMount() {
    this.getAvlChips();
  },
  data: () => ({
    avlChipOptions: [],
    isLoading: true,
  }),
  methods: {
    label(avlChip) {
      try {
        return `Avl: ${avlChip.id_avl} - Chip: ${avlChip.numeroChip}${
          avlChip.reportando ? " (reportando)" : ""
        }`;
      } catch (e) {
        console.log(e);
        return JSON.stringify(avlChip);
      }
    },
    async getAvlChips() {
      this.isLoading = true;
      const resp = await axios.post("/execute", {
        method: "CLI.GetAvlChip",
        parameters: [],
      });
      if (resp.data.ok) {
        this.avlChipOptions = get(resp, "data.result[0]", []);
      } else {
        this.$msgBoxOk(resp.data.message);
      }
      this.isLoading = false;
    },
  },
  computed: {
    avlChip: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>
